export default function createCropperPalette(theme, current, _base) {
    return {
        cropper: {
            backgroundColor: current[500],
            borderColor: current[500],
            outlineColor: current[500],
        },
    };
}
//# sourceMappingURL=cropper.js.map